import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import HoverVideoTile from './Views/TileVideo';
import ImageTile from './Views/TileImage';
import ImageOverlay from './Views/ImageOverlay';

class TileContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHoverImage: false,
      isPlaying: false,
      renderImage: true,
      renderLiveVideo: false,
      renderPreviewVideo: false,
      renderImageOverlay: false,
    };
  }

  shouldComponentUpdate(nextProps) {
    const newProps = this.getChangingProps(nextProps);
    const oldProps = this.getChangingProps(this.props);
    return !_.isEqual(newProps, oldProps);
  }

  getChangingProps = props => {
    const {
      altText,
      favoritesManager,
      guid,
      hoverImage,
      id,
      image,
      isCollectionCategoryList,
      isHoverStateV2,
      name,
      overlayProps,
      preventLazyLoad,
      theme,
      video,
    } = props;
    return {
      altText,
      favoritesManager,
      guid,
      hoverImage,
      id,
      image,
      isCollectionCategoryList,
      isHoverStateV2,
      name,
      overlayProps,
      preventLazyLoad,
      theme,
      video,
    };
  };

  handleMouseEnter = () => {
    const { hoverImage, isHoverStateV2, overlayProps, toggleNetworkIcon, video } = this.props;
    let nextState = {};
    if (video && !isHoverStateV2) {
      nextState = {
        ...nextState,
        renderPreviewVideo: true,
        renderImage: false,
        isPlaying: true,
      };
    } else if (hoverImage) {
      nextState = { ...nextState, isHoverImage: true };
    }

    if (overlayProps) {
      nextState = { ...nextState, renderImageOverlay: true };
      toggleNetworkIcon(false);
    }
    if (!_.isEmpty(nextState)) this.setState(nextState);
  };

  handleMouseLeave = () => {
    const { toggleNetworkIcon } = this.props;
    const { renderImageOverlay } = this.state;
    this.setState(
      {
        isHoverImage: false,
        isPlaying: false,
        renderImage: true,
        renderImageOverlay: false,
        renderPreviewVideo: false,
      },
      () => {
        if (renderImageOverlay) toggleNetworkIcon(true);
      },
    );
  };

  renderPreviewVideo() {
    const { isPlaying, renderPreviewVideo } = this.state;
    const { altText, image, renderImage, video } = this.props;

    return (
      <HoverVideoTile
        altText={altText}
        image={image}
        play={isPlaying}
        rendered={renderPreviewVideo}
        renderImage={renderImage}
        video={video}
      />
    );
  }

  renderLiveVideo() {
    const { isPlaying, renderLiveVideo } = this.state;
    const { altText, image, renderImage, video } = this.props;

    return (
      <HoverVideoTile
        altText={altText}
        image={image}
        play={isPlaying}
        rendered={renderLiveVideo}
        renderImage={renderImage}
        video={video}
      />
    );
  }

  renderImage() {
    const { renderImage, isHoverImage } = this.state;
    const {
      altText,
      hoverImage,
      image,
      isCollectionCategoryList,
      isTileGrid,
      name,
      preventLazyLoad,
      renderImage: renderDynamicImage,
      theme,
    } = this.props;
    let imageToRender = image || hoverImage;

    if (isHoverImage && hoverImage) {
      imageToRender = hoverImage;
    }

    return (
      <ImageTile
        altText={altText}
        image={imageToRender}
        isCollectionCategoryList={isCollectionCategoryList}
        isHover={isHoverImage}
        isTileGrid={isTileGrid}
        name={name}
        preventLazyLoad={preventLazyLoad}
        rendered={renderImage}
        renderImage={renderDynamicImage}
        theme={theme}
      />
    );
  }

  renderImageOverlay() {
    const { renderImageOverlay } = this.state;
    const {
      favoritesManager,
      isCollectionCategoryList,
      isMobileDevice,
      overlayProps,
      theme,
    } = this.props;
    const shouldRenderOverlay = !isCollectionCategoryList && !isMobileDevice;

    return (
      shouldRenderOverlay && (
        <ImageOverlay
          {...overlayProps}
          data-test="tile-image-overlay"
          favoritesManager={favoritesManager}
          renderImageOverlay={renderImageOverlay}
          theme={theme}
        />
      )
    );
  }

  render() {
    const previewVideo = this.renderPreviewVideo();
    const liveVideo = this.renderLiveVideo();
    const tileImage = this.renderImage();
    const imageOverlay = this.renderImageOverlay();

    const tileHoverProps = {
      onMouseEnter: () => this.handleMouseEnter(),
      onMouseLeave: () => this.handleMouseLeave(),
    };

    return (
      <div {...tileHoverProps}>
        {previewVideo}
        {liveVideo}
        {tileImage}
        {imageOverlay}
      </div>
    );
  }
}

TileContent.defaultProps = {
  altText: '',
  favoritesManager: null,
  guid: null,
  hoverImage: null,
  id: null,
  image: null,
  isHoverStateV2: false,
  isMobileDevice: false,
  isTileGrid: false,
  name: null,
  overlayProps: null,
  preventLazyLoad: false,
  renderImage: () => {},
  theme: {},
  toggleNetworkIcon: () => {},
  video: null,
};

TileContent.propTypes = {
  altText: PropTypes.string,
  favoritesManager: PropTypes.shape({}),
  guid: PropTypes.string,
  hoverImage: PropTypes.string,
  id: PropTypes.string,
  image: PropTypes.string,
  isCollectionCategoryList: PropTypes.bool,
  isHoverStateV2: PropTypes.bool,
  isMobileDevice: PropTypes.bool,
  isTileGrid: PropTypes.bool,
  name: PropTypes.string,
  overlayProps: PropTypes.shape({}),
  preventLazyLoad: PropTypes.bool,
  renderImage: PropTypes.func,
  theme: PropTypes.shape({}),
  toggleNetworkIcon: PropTypes.func,
  video: PropTypes.string,
};

export default React.memo(TileContent);
